import React, { memo, useEffect, useState } from "react";
import HeaderAndSidebar from "../Lib/HeaderAndSidebar";
import ProposalSubmission from "../../stories/ProposalSubmission";
import useStartupStore from "../../stores/startupStore";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Anchor, Group, Loader } from "@mantine/core";
import TableOfContentsFloating from "../../stories/TOC";
import ProjectDetailsCard from "../../stories/ProjectDetailsCard";
import { IconArrowLeft } from "@tabler/icons-react";

const MemoApplicationShow = memo(ApplicationShow);

const useStartup = (slug, setStartup, data) => {
  return useQuery({
    queryKey: ["startup", slug],
    queryFn: async () => {
      if (!data || data === null) {
        throw new Error('Application data is missing or null');
      }
      setStartup(data);
      return data;
    },
    retry: 1,
    staleTime: 5 * 60 * 1000,
    cacheTime: 30 * 60 * 1000,
  });
};

export default function ApplicationContainer({ data }) {
  return (
    <HeaderAndSidebar>
      <MemoApplicationShow appData={data} />
    </HeaderAndSidebar>
  );
}

function ApplicationShow({ appData }) {
  const { slug } = useParams();

  const { setStartup } = useStartupStore((state) => ({
    setStartup: state.setStartup,
  }));
  console.log(appData);

  const { isLoading, isError, error, data } = useStartup(
    slug,
    setStartup,
    appData
  );

  console.log(appData)

  if (isLoading) {
    return (
      <Loader
        className="mx-auto mt-10"
        color="indigo"
        size="lg"
        variant="dots"
      />
    );
  }

  const applicationStatus = data?.status;
  const isLocked = applicationStatus === "accepted" || applicationStatus === "rejected";

  return (
    <div className="w-full">
      <Anchor onClick={() => window.history.back()} target="_blank">
          <Group className="mb-2" spacing={4} h>
            <IconArrowLeft size={18} color="#1c7ed6" />
            Go back
          </Group>
        </Anchor>
      <div className="flex gap-6 justify-center">
        <TableOfContentsFloating editMode={!isLocked} disableEditIcon={isLocked} showButtons={true} />
        <ProposalSubmission
          initialSquad={data.squad}
          initialUser={data.user}
          isProjectOwnerView={data.project_owner}
          initialAttachedFiles={data.files}
          initialProposalText={data.pitch}
          initialBudget={data.startup_entity.budget || 0.0}
          project={data.original_startup_entity}
          initialApplicationSlug={data.slug}
          applicationStatus={data.status}
          rejectionReason={data.rejection_reason}
          name={data?.original_startup_entity?.name || data?.startup_entity?.name}
        />
      </div>
    </div>
  );
}
